/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'
import { JBP_COMMITTED_SHELF_FRAGMENT } from './JBPCommittedShelfFragment'

export const JBP_CONTRACT_FRAGMENT = gql`
  fragment JBPContract on JBPContract {
    id
    plan {
      id
      name
      requirements(companyStoreId: $companyStoreId) {
        id
        name
        spaceRequired
        totalSpaceRequired
        required
      }
    }
    committedShelves {
      ...JBPCommittedShelf
    }
  }
  ${JBP_COMMITTED_SHELF_FRAGMENT}
`
